import React, { useEffect } from "react";
import { bool, node, string } from "prop-types";

import { useSticky } from "src/shared/utilities/stickyHelpers";

import useInView from "../../utilities/useInView";
import * as S from "./styled";

const ContactButtonBox = ({ children, className, isMobile, ...props }) => {
  const { inView, ref } = useInView();
  const [value, setValue] = useSticky(isMobile);

  useEffect(() => {
    setValue(!inView);
  }, [inView, isMobile, value]);

  return (
    <S.ContactBox ref={ref} className={className} {...props}>
      {children}
    </S.ContactBox>
  );
};

ContactButtonBox.propTypes = {
  children: node.isRequired,
  className: string,
  isMobile: bool
};

ContactButtonBox.defaultProps = {
  className: "",
  isMobile: false
};

export default ContactButtonBox;
